<template>
	<div>
		<app-table
			class="is-not-selectable pa-4"
			name="action-list"
			:columns="columns"
			:current-page="currentPage"
			:rows="rows"
			:last-page="lastPage"
		>
			<template slot="rows" slot-scope="props">
				<td
					class="is-not-selectable"
				>
					{{ props.row.domain }}
				</td>
				<td>{{ props.row.method }}</td>
				<td>{{ props.row.path }}</td>
				<td>{{ props.row.name }}</td>
				<td>
					<v-checkbox
						class="mt-0 pl-3"
						color="success"
						hide-details
						v-model="props.row.flagAuth">
					</v-checkbox>
				</td>
				<td>
					<button 
						class="btn-add"
						@click="addService(props.row)">
						<img 
							src="https://s3.amazonaws.com/apprunn-acl/icons/&0EgoiJCAh5Bh9z8o99lwzntsZzIlI.svg" 
							alt="Agregar"
							height="15">
					</button>
				</td>
			</template>
		</app-table>
	</div>
</template>
<script>

async function loadData() {
	try {
		const { data: response } = await this.$http.get('master-services', { params: this.paramsService });
		this.rows = response.data.map((s) => {
			const newService = { ...s };
			newService.flagAuth = false;
			return newService;
		});
	} catch (error) {
		this.showError();
	}
}

function addService(row) {
	this.$emit('add-service', row);
}

function created() {
	this.loadData();
}

function data() {
	return {
		columns: [
			{ id: 1, name: 'Dominio', checked: true, visible: true },
			{ id: 2, name: 'Método', checked: true, visible: true },
			{ id: 3, name: 'URI', checked: true, visible: true },
			{ id: 4, name: 'Nombre', checked: true, visible: true },
			{ id: 5, name: 'Auth', checked: true, visible: true },
			{ id: 6, name: 'Acciones', checked: true, visible: true },
		],
		currentPage: 1,
		lastPage: 0,
		rows: [],
	};
}

export default {
	name: 'resource-search',
	data,
	created,
	methods: {
		loadData,
		addService,
	},
	props: {
		codeProject: {
			type: String,
		},
		paramsService: {
			default: () => {},
			type: Object,
		},
	},
};
</script>
<style lang="scss" scoped>
	.btn-add {
		background: map-get($colors, tab);
		border-radius: 5px;
		margin: 5px;
		padding: 5px 19px;
	}
</style>


// WEBPACK FOOTER //
// src/components/resource-service/resource-search.vue